import axios from 'axios';

const locationApi = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1/localidades/',
});

export default locationApi;
